import type { ReactElement } from 'react';

import AppStoreIcon from 'consumer/icons/appstore.png';
import PlayStoreIcon from 'consumer/icons/playstore.png';

type Props = {
  onClick?: () => void,
};

function AppStoreLink({ onClick }: Props): ReactElement {
  return (
    <div className="c-footer__buttton-row">
      <a
        href="https://apps.apple.com/us/app/id6444125328"
        target="_blank"
        rel="noreferrer"
        aria-label="Download on the AppStore"
        onClick={onClick}
      >
        <img src={AppStoreIcon} alt="Download on the Play Store" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.purplecarrot.mobile"
        target="_blank"
        rel="noreferrer"
        aria-label="Download on the Play Store"
        onClick={onClick}
      >
        <img src={PlayStoreIcon} alt="Download on the Play Store" />
      </a>
    </div>
  );
}

export default AppStoreLink;
